const reviewsOpenText = () => {
  const OpenText = document.querySelectorAll('.reviews_btn');
  const ReviewsText = document.querySelectorAll('.reviews_text');
  OpenText.forEach((item, idx) => {
    item.addEventListener('click', () => {
      ReviewsText[idx].style.height = ReviewsText[idx].scrollHeight + 'px';
      item.classList.add('visually-hidden');
    });
  });
};
export default reviewsOpenText;
